module.exports = __webpack_public_path__ + "static/award7-8821acc7681cdfe333138c252c166936.png";